<template>
   <section class="phone_container">
        <section class="add_con">
            <input
                class="phone_input"
                placeholder="请输入手机号"
                v-model="phone"
                @input="handleInput"
                @keyup.enter= "addPhone"
            />
            <div v-if="!!phone" class="big_phone">{{spacePhone}}</div>
            <el-button class="phone_add_btn" v-on:click="addPhone">添加</el-button>
        </section>
        <p class="tips"><i  class="el-icon-info"></i>您承诺您填写的手机号已获取个人信息主体授权同意</p>
        <ul class="item_con">
            <li class="item" v-for="(item,index) in spacePhones" :key="item" >
                <span class="phone">{{item}}</span>
                <span class="del" v-on:click="deletePhone(index,item)">删除</span>
            </li>
        </ul>
   </section>
</template>
<script>
import { Message } from 'element-ui'
const phoneReg = /^1[1|3|4|5|6|7|8|9]\d{9}$/
export default {
  name: 'AddPhone',
  componentName: 'AddPhone',
  data () {
    return {
      phone: '',
      spacePhone: '',
      spacePhones: [],
      phones: []
    //   phoneMap: {}
    }
  },
  methods: {
    handleInput: function (e) {
      //   console.log(222)
      this.phone = e.target.value.replace(/[^\d]/g, '')
      if (/^\d{4,7}$/g.test(this.phone)) {
        this.spacePhone = this.phone.replace(/^(\d{3})(\d{1,4})/, '$1 $2')
      } else if (/^\d{8,}$/g.test(this.phone)) {
        this.spacePhone = this.phone.replace(/^(\d{3})(\d{4})(\d{1,})/, '$1 $2 $3')
      } else {
        this.spacePhone = this.phone
      }
    },
    addPhone: function () {
    //   console.log(this.phone)
      if (!phoneReg.test(this.phone)) {
        return Message.error('手机号码有误')
      }
      if (this.phones.length === 5) {
        return Message.error('最多添加5个手机号码')
      }
      if (this.phones.includes(this.phone)) {
        return Message.error('手机号码重复')
      }
      this.phones.push(this.phone)
      this.spacePhones.push(this.spacePhone)
      // this.phoneMap[this.phone] = 1
      this.$emit('listenPhoneChange', this.phones, this.spacePhones)
      this.phone = ''
    },
    deletePhone: function (index, item) {
      this.phones.splice(index, 1)
      this.spacePhones.splice(index, 1)
      //   delete this.phoneMap[this.phone]
      this.$emit('listenPhoneChange', this.phones, this.spacePhones)
    }
  }
}
</script>

<style scoped lang="stylus">
    .phone_container{
        padding:20px 20px 0
        .tips{
          font-size: 12px;
          font-weight: normal;
          line-height: 14px;
          letter-spacing: 0px;
          padding-top: 10px
          color: #999999;
          .el-icon-info{
            margin-right: 3px
          }
        }
        .add_con{
            margin-top: 10px
            position: relative
            .big_phone{
                position: absolute
                width: 228px
                height: 40px
                line-height :40px
                padding: 0 10px
                font-size: 18px
                background: #FFFFFF
                color: #333333;
                font-weight:500;
                box-shadow: 0 4px 16px 0 rgba(0,0,0,0.15)
            }
            .phone_input{
                width: 225px
                height: 36px
                font-size: 14px;
                outline :none;
                color: #666;

                padding: 0 10px
            }
            input:-ms-input-placeholder{
                color: #FF5722
                font-size:14px
            }
            input::-ms-input-placeholde{
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #999
            }
            input:-moz-placeholder{
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #999
            }
            input::-moz-placeholder{
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #999
            }
            input::-webkit-input-placeholder{
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #999
            }
            .phone_add_btn{
                position relative
                margin-left 10px
                top -2px
                background none
                color #3468ff
            }
            .phone_add_btn:hover,.phone_add_btn:focus{
                background #EAEFFF
                border-color  #5f88ff
            }
        }
        .item_con{
            font-family: PingFangSC-Medium, sans-serif
            padding-top 20px
            .item{
                padding-bottom: 20px
                float: left
                height: 24px
                line-height: 24px
                width: 218px
                .phone{
                    font-size: 24px
                    color: #333
                    vertical-align: middle
                }
                .del{
                    vertical-align: middle
                    display: inline-block
                    font-size: 14px
                    color: #3468FF
                    margin-left: 10px
                    cursor: pointer
                }
            }
        }
        .item_con:after{
            clear:both
            content:'.'
            display:block
            width: 0
            height: 0
            visibility:hidden
        }
    }
</style>
